module.exports = __webpack_public_path__ + "img/portrait-background.0e0b08c3.png";